<template>
  <div
    class="inline-flex items-center justify-center rounded-lg p-1 bg-red-100/80 backdrop-blur-[2px] gap-1"
  >
    <IconShield
      class="shrink-0 size-5 text-red-alfa-insurance"
      aria-hidden="true"
    />
    <span
      v-if="showText"
      class="text-xs leading-3 font-bold text-red-alfa-insurance whitespace-nowrap"
    >
      Со страховкой
    </span>
  </div>
</template>

<script setup>
import IconShield from '~/assets/svg/ui/shield.svg?component'

defineProps({
  showText: {
    type: Boolean,
    default: true,
  },
})
</script>
